(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/sport-products/assets/javascripts/get-class-name.js') >= 0) return;  svs.modules.push('/components/lb-utils/sport-products/assets/javascripts/get-class-name.js');
"use strict";


const isServer = typeof exports === 'object';
const productIds = isServer ? require('./product-ids.es6') : svs.components.lbUtils.sportProducts.productIds;
const resolveProductId = isServer ? require('./resolve-product-id.es6') : svs.components.lbUtils.sportProducts.resolveProductId;
const getProductClassNameFromShared = isServer ? require('trinidad-core').core.components.require('utils', 'products').getProductClassName : svs.utils.products.getProductClassName;
const getClassName = anyInput => {
  const productId = resolveProductId(anyInput);
  if (!productId) {
    return '';
  }
  switch (productId) {
    case productIds.CASINO:
      return 'casino';
    case productIds.LIVE_CASINO:
      return 'live-casino';
    case productIds.POKER:
      return 'poker';
    case productIds.MOMANG:
      return 'momang';
    case productIds.BINGO_M:
    case productIds.BINGO_CLASSIC_SINGEL:
    case productIds.BINGO_CLASSIC:
    case productIds.BINGO_PATTERN_SINGEL:
    case productIds.BINGO_PATTERN:
    case productIds.BINGO_VARIANT_SINGEL:
    case productIds.BINGO_VARIANT:
      return 'bingo';
    case productIds.YATZY:
      return 'yatzy';
    default:
      return getProductClassNameFromShared(productId);
  }
};
if (svs.isServer) {
  module.exports = getClassName;
} else {
  setGlobal('svs.components.lbUtils.sportProducts', {
    getClassName
  });
}

 })(window);